import { trf } from '../../lib/i18n';
import { lienAppel } from '../../lib/portable';
import { C } from '../../theme/palette';

/**
 * Le chantier où livrer et la personne à appeler en arrivant — celle qui a
 * passé la commande : un gros bouton « 📞 Appeler », d'un pouce, camion à
 * l'arrêt.
 *
 * @param {object} props propriétés
 * @param {string} [props.chantier] chantier où livrer
 * @param {string} [props.numero] numéro du chantier chez le client
 * @param {string} [props.nom] personne à appeler
 * @param {string} [props.telephone] son portable
 * @param {object} [props.style] marges du bloc
 * @returns {import('react').ReactElement|null} le bloc, rien sans chantier ni contact
 */
export function ContactSurPlace({ chantier, numero, nom, telephone, style }) {
  const lien = lienAppel(telephone);
  if (!chantier && !numero && !lien && !nom) return null;
  return (
    <div style={style}>
      {(chantier || numero) && (
        <div style={{ fontSize: 13, fontWeight: 800, color: C.ink, marginBottom: 6 }}>
          🏗 <span translate="no">{[numero, chantier].filter(Boolean).join(' · ')}</span>
        </div>
      )}
      {lien ? (
        <a
          href={lien}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
            minHeight: 52,
            boxSizing: 'border-box',
            padding: '12px 14px',
            borderRadius: 12,
            background: C.green,
            color: '#fff',
            fontSize: 16,
            fontWeight: 900,
            textDecoration: 'none',
          }}
        >
          {nom ? trf('📞 Appeler {0}', nom) : '📞 Appeler'}
          <span
            style={{ fontWeight: 600, fontSize: 13, opacity: 0.9, whiteSpace: 'nowrap' }}
            translate="no"
          >
            {telephone}
          </span>
        </a>
      ) : (
        nom && <div style={{ fontSize: 12, color: C.grey }}>{trf('Contact : {0}', nom)}</div>
      )}
    </div>
  );
}
